import React from 'react';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import { Badge } from 'reactstrap';
import DateToHuman from '../../../components/DateToHuman';

const displayDate = (value) => (value === undefined || value === null || value === '' ? '-' : value);

const RowItem = ({ number, id, productVariant, active, startedAt, endedAt, updatedAt, defaultRoute }) => {
  const brand = productVariant && productVariant.product && productVariant.product.brand
    ? productVariant.product.brand.name
    : null;
  return (
    <tr>
      <th scope="row" className="v-center">{number}</th>
      <td className="v-center">
        {brand ? <p className="mb-0" style={{ fontSize: '.65rem', color: '#909090' }}>{brand}</p> : null}
        <p className="mb-0"><b>{productVariant ? productVariant.display_name : '-'}</b></p>
        {productVariant && productVariant.SKU ? (
          <p className="mb-0" style={{ fontSize: '.65rem' }}>{productVariant.SKU}</p>
        ) : null}
      </td>
      <td className="v-center">
        {active
          ? <Badge color="success">Active</Badge>
          : <Badge color="default">Inactive</Badge>}
      </td>
      <td className="v-center">
        <p className="mb-0" style={{ fontSize: '.75rem' }}><b>Start:</b> {displayDate(startedAt)}</p>
        <p className="mb-0" style={{ fontSize: '.75rem' }}><b>End:</b> {displayDate(endedAt)}</p>
      </td>
      <td className="v-center">
        <DateToHuman value={updatedAt} id={`tooltip_kpr_updatedAt_item_${number}`} />
      </td>
      <td className="v-center">
        <Link to={`${defaultRoute}/${id}`} className="btn btn-secondary btn-sm btn-link"> Details</Link>
      </td>
    </tr>
  )
}

export default RowItem;

RowItem.propTypes = {
  id: propTypes.number.isRequired,
  number: propTypes.number.isRequired,
  productVariant: propTypes.object,
  active: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  startedAt: propTypes.string,
  endedAt: propTypes.string,
  updatedAt: propTypes.string,
  defaultRoute: propTypes.string.isRequired,
}

RowItem.defaultProps = {
  active: false,
  productVariant: null,
}
